var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/TagExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/fonts/fonts.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { BaseTag } from "../../db/extensions/BaseTag.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import { Size } from "../globals/enums.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var TagExtension = {
  class: BaseTag,
  toolbar: { icon: "tag", text: { default: "Tag" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-tag-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-tag-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath, host }) {
    return html`
      <x-flex space="md">
        ${repeat(
      content.texts ?? [],
      (text) => text,
      (text, i) => html`
              <x-flex horizontal crossaxis-center space="sm">
                <x-input
                  flex
                  placeholder="Text"
                  ${contentController.field(...controllerBaseKeyPath, "texts", i)}
                ></x-input>
                <x-button
                  mode="icon"
                  icon="delete"
                  tone="error"
                  @click=${() => {
        content.texts.splice(i, 1);
        host.requestUpdate();
      }}
                ></x-button>
              </x-flex>
            `
    )}
        <x-button
          mode="outline"
          icon="add"
          @click=${() => {
      if (!content.texts)
        content.texts = [];
      content.texts.push("");
      host.requestUpdate();
    }}
        >
          Tag hinzufügen
        </x-button>
      </x-flex>
    `;
  },
  group: "Schriften"
};
var XTagExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return html`
      <x-flex
        horizontal
        wrap
        crossaxis-start
        ${css({ gap: this.defaultValue("gap", { global: "8px", [Size.MOBILE]: "4px" }) })}
      >
        ${content.texts.map((text) => this._renderTag(text))}
      </x-flex>
    `;
  }
  _renderTag(text) {
    return html`
      <x-flex
        center
        crossaxis-center
        ${css({
      borderRadius: this.sizes.borderRadius,
      backgroundColor: "#CECECE",
      padding: "8px",
      width: "max-content"
    })}
      >
        <x-text> ${text ?? "#tag"} </x-text>
      </x-flex>
    `;
  }
};
XTagExtension = __decorateClass([
  customElement("x-tag-extension")
], XTagExtension);
export {
  TagExtension,
  XTagExtension
};
